<template>
    <span>
        <v-input v-if="showEditor" type="text" @change="$emit('change', $event)" @enter="$emit('enter', $event)" :currentValue="note.note"></v-input>
        <div class="note" v-else>
            <blockquote>
                <div>
                    {{ note.note }}
                </div>
                <small>
                    &mdash;
                    <user :user="user" mode="tiny"/>
                    <timestamp :time="note.updated_at"></timestamp>
                </small>
                <span class="tooltip-left" data-tooltip="Delete Note">
                  <i class="fa fa-minus" @click="deleteTripNote"></i>
                </span>
            </blockquote>
        </div>
    </span>
</template>

<script>
    import User from './User.vue'
    import Timestamp from './Timestamp.vue'

    export default {
      data () {
        return {
          newValue: '',
          editing: false,
        }
      },
      props: {
        note: null
      },
      components: {
          'user': User,
          'timestamp': Timestamp
      },
      created () {
        this.newValue = this.note.note
      },
      computed: {
        user() {
            this.$privateReactiveStore.getProductSpecialist(this.note.user_id);
        },
        showEditor () {
          return (
            this.editing
            || this.newValue === 0
            || this.newValue === '0'
            || this.newValue === null
            || this.newValue === ''
          )
        },
      },
      methods: {
        deleteTripNote () {
          this.$eventHub.$emit('deleteTripNote', this.note);
        }
      }
    }
</script>

<style scoped lang="less">
    .note .full_name::after {
        content: ',';
    }

    i.fa-minus {
       color: #d90074;
    }
</style>